import React, { useMemo } from 'react';
import { LEADS } from '../data/leads';

/* ── City coordinates lookup (German cities) ── */
const CITY_COORDS = {
  'Aachen': [50.7753, 6.0839],
  'Augsburg': [48.3705, 10.8978],
  'Bad Homburg': [50.2270, 8.6170],
  'Bamberg': [49.8988, 10.9028],
  'Bayreuth': [49.9456, 11.5713],
  'Berlin': [52.5200, 13.4050],
  'Bielefeld': [52.0302, 8.5325],
  'Bochum': [51.4818, 7.2162],
  'Bonn': [50.7374, 7.0982],
  'Bottrop': [51.5236, 6.9218],
  'Braunschweig': [52.2689, 10.5268],
  'Breisach': [48.0310, 7.5757],
  'Bremen': [53.0793, 8.8017],
  'Bremerhaven': [53.5390, 8.5800],
  'Chemnitz': [50.8278, 12.9214],
  'Cottbus': [51.7563, 14.3329],
  'Darmstadt': [49.8728, 8.6512],
  'Dortmund': [51.5136, 7.4653],
  'Dresden': [51.0504, 13.7373],
  'Duisburg': [51.4349, 6.7623],
  'Düsseldorf': [51.2217, 6.7762],
  'Erfurt': [50.9787, 11.0328],
  'Erlangen': [49.5897, 11.0078],
  'Essen': [51.4556, 7.0116],
  'Esslingen': [48.7427, 9.3122],
  'Frankfurt': [50.1109, 8.6821],
  'Frankfurt am Main': [50.1109, 8.6821],
  'Freiburg': [47.9990, 7.8421],
  'Freiburg im Breisgau': [47.9990, 7.8421],
  'Friedrichshafen': [47.6550, 9.4788],
  'Fulda': [50.5557, 9.6750],
  'Gelsenkirchen': [51.5177, 7.0857],
  'Göttingen': [51.5341, 9.9317],
  'Hagen': [51.3670, 7.4637],
  'Halle': [51.4828, 11.9697],
  'Hamburg': [53.5753, 10.0153],
  'Hamm': [51.6739, 7.8224],
  'Hannover': [52.3759, 9.7320],
  'Heidelberg': [49.3988, 8.6724],
  'Heilbronn': [49.1396, 9.2202],
  'Herne': [51.5378, 7.2157],
  'Ingolstadt': [48.7665, 11.4258],
  'Jena': [50.9272, 11.5898],
  'Kaiserslautern': [49.4440, 7.7689],
  'Karlsruhe': [49.0069, 8.4037],
  'Kassel': [51.3127, 9.4797],
  'Kiel': [54.3233, 10.1228],
  'Koblenz': [50.3569, 7.5890],
  'Konstanz': [47.6779, 9.1732],
  'Krefeld': [51.3388, 6.5853],
  'Köln': [50.9333, 6.9500],
  'Cologne': [50.9333, 6.9500],
  'Leipzig': [51.3397, 12.3731],
  'Leverkusen': [51.0459, 6.9841],
  'Lübeck': [53.8655, 10.6866],
  'Ludwigsburg': [48.8975, 9.1919],
  'Ludwigshafen': [49.4774, 8.4453],
  'Lüdenscheid': [51.2196, 7.6284],
  'Lörrach': [47.6148, 7.6596],
  'Magdeburg': [52.1205, 11.6276],
  'Mainz': [49.9929, 8.2473],
  'Mannheim': [49.4875, 8.4660],
  'Marburg': [50.8021, 8.7703],
  'Moers': [51.4509, 6.6352],
  'Mönchengladbach': [51.1805, 6.4428],
  'Mülheim': [51.4331, 6.8801],
  'München': [48.1351, 11.5820],
  'Münster': [51.9607, 7.6261],
  'Nürnberg': [49.4521, 11.0767],
  'Oberhausen': [51.4692, 6.8516],
  'Offenburg': [48.4736, 7.9408],
  'Oldenburg': [53.1435, 8.2146],
  'Osnabrück': [52.2799, 8.0472],
  'Paderborn': [51.7189, 8.7575],
  'Pforzheim': [48.8921, 8.6944],
  'Potsdam': [52.3906, 13.0645],
  'Recklinghausen': [51.6142, 7.1973],
  'Regensburg': [49.0134, 12.1016],
  'Remscheid': [51.1798, 7.1896],
  'Rostock': [54.0924, 12.0991],
  'Reutlingen': [48.4906, 9.2106],
  'Saarbrücken': [49.2354, 6.9969],
  'Salzgitter': [52.1549, 10.3689],
  'Schwerin': [53.6355, 11.4010],
  'Siegen': [50.8750, 8.0239],
  'Sindelfingen': [48.7139, 9.0020],
  'Solingen': [51.1717, 7.0832],
  'Stuttgart': [48.7758, 9.1829],
  'Tübingen': [48.5216, 9.0576],
  'Ulm': [48.4011, 9.9876],
  'Villingen-Schwenningen': [48.0594, 8.4561],
  'Wiesbaden': [50.0782, 8.2398],
  'Wolfsburg': [52.4227, 10.7865],
  'Wuppertal': [51.2562, 7.1508],
  'Würzburg': [49.7913, 9.9534],
};

export const REGION_RADIUS_KEY = 'crm_region_radius_km';
export const REGION_PENDING_KEY = 'crm_pending_region_session';

export function loadRegionRadius() {
  try { return Math.max(5, Math.min(200, parseInt(localStorage.getItem(REGION_RADIUS_KEY) || '30', 10) || 30)); } catch { return 30; }
}

export function saveRegionRadius(km) {
  try { localStorage.setItem(REGION_RADIUS_KEY, String(km)); } catch {}
}

function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const toRad = x => x * Math.PI / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.asin(Math.sqrt(a));
}

function resolveCityCoords(city) {
  if (!city) return null;
  const trimmed = city.trim();
  if (CITY_COORDS[trimmed]) return CITY_COORDS[trimmed];
  const lower = trimmed.toLowerCase();
  const key = Object.keys(CITY_COORDS).find(k => k.toLowerCase() === lower || lower.startsWith(k.toLowerCase()) || k.toLowerCase().startsWith(lower));
  return key ? CITY_COORDS[key] : null;
}

export function findNearbyLeads(sourceLead, allLeads, radiusKm) {
  if (!sourceLead?.city) return [];
  const src = resolveCityCoords(sourceLead.city);
  if (!src) return [];

  const withDist = allLeads
    .filter(l => l.id !== sourceLead.id)
    .reduce((acc, l) => {
      const c = resolveCityCoords(l.city);
      if (!c) return acc;
      const dist = haversineKm(src[0], src[1], c[0], c[1]);
      if (dist <= radiusKm) acc.push({ ...l, _distKm: Math.round(dist) });
      return acc;
    }, []);

  return withDist.sort((a, b) => a._distKm - b._distKm).slice(0, 20);
}

/* ── Main modal component ── */
export default function RegionalSuggestionModal({ sourceLead, onClose, onStartSession }) {
  const radiusKm = loadRegionRadius();

  const allLeads = useMemo(() => {
    try {
      const s = localStorage.getItem('crm_leads');
      return s ? JSON.parse(s) : LEADS;
    } catch { return LEADS; }
  }, []);

  const nearbyLeads = useMemo(
    () => findNearbyLeads(sourceLead, allLeads, radiusKm),
    [sourceLead, allLeads, radiusKm]
  );

  function handleStartSession() {
    if (nearbyLeads.length === 0) { onClose(); return; }
    onStartSession?.({
      leads: nearbyLeads.map(({ _distKm, ...l }) => ({ ...l, _distKm })),
      sourceCity: sourceLead.city,
      radiusKm,
      label: `Region ${sourceLead.city} – ${radiusKm} km`,
    });
    onClose();
  }

  const hasCoords = !!resolveCityCoords(sourceLead?.city);

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, zIndex: 600,
        background: 'rgba(15,23,42,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <div style={{
        background: 'var(--bg2)', borderRadius: 16, width: 480, maxWidth: '94vw',
        maxHeight: '85vh', display: 'flex', flexDirection: 'column',
        boxShadow: '0 24px 64px rgba(15,23,42,0.28)', border: '1px solid var(--border)',
        overflow: 'hidden',
      }}>

        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #16a34a, #15803d)',
          padding: '18px 20px', flexShrink: 0,
          display: 'flex', alignItems: 'flex-start', gap: 14,
        }}>
          <div style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M20 6L9 17l-5-5"/>
            </svg>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#fff' }}>Termin erfolgreich gesetzt!</div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', marginTop: 3 }}>
              {sourceLead.name} · {sourceLead.company}
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, width: 30, height: 30, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'background .1s' }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.25)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        {/* Question banner */}
        <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border)', background: 'rgba(22,163,74,0.04)', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(22,163,74,0.1)', border: '1.5px solid rgba(22,163,74,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                <circle cx="12" cy="9" r="2.5" fill="#16a34a"/>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)' }}>
                Weitere Termine in der Region legen?
              </div>
              <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>
                {!hasCoords ? (
                  <span>Keine Koordinaten für „{sourceLead.city}" verfügbar</span>
                ) : nearbyLeads.length === 0 ? (
                  <span>Keine weiteren Unternehmen im Umkreis von {radiusKm} km gefunden</span>
                ) : (
                  <span>
                    <strong style={{ color: '#16a34a' }}>{nearbyLeads.length}</strong> Unternehmen im Umkreis von <strong>{radiusKm} km</strong> um {sourceLead.city}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Lead list */}
        {nearbyLeads.length > 0 && (
          <div style={{ flex: 1, overflowY: 'auto', padding: '10px 20px' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8 }}>
              Vorgeschlagene Unternehmen
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              {nearbyLeads.map(l => (
                <div key={l.id} style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '8px 12px', borderRadius: 9,
                  background: 'var(--bg3)', border: '1px solid var(--border)',
                }}>
                  <div style={{
                    width: 30, height: 30, borderRadius: '50%',
                    background: 'rgba(22,163,74,0.1)', color: '#16a34a',
                    border: '1.5px solid rgba(22,163,74,0.2)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 11, fontWeight: 700, flexShrink: 0,
                  }}>
                    {l.name.split(' ').slice(0, 2).map(x => x[0]).join('').toUpperCase()}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.company}</div>
                    <div style={{ fontSize: 11, color: 'var(--text3)' }}>{l.name} · {l.city}</div>
                  </div>
                  <span style={{
                    fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 20,
                    background: 'rgba(22,163,74,0.08)', color: '#16a34a',
                    border: '1px solid rgba(22,163,74,0.2)', whiteSpace: 'nowrap', flexShrink: 0,
                  }}>
                    {l._distKm} km
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Buttons */}
        <div style={{ padding: '14px 20px', borderTop: '1px solid var(--border)', display: 'flex', gap: 10, flexShrink: 0 }}>
          <button onClick={onClose} style={{
            flex: 1, height: 40, borderRadius: 10,
            background: 'var(--bg3)', border: '1px solid var(--border)',
            color: 'var(--text2)', fontSize: 13, fontWeight: 500, cursor: 'pointer',
            fontFamily: 'inherit', transition: 'all .12s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = 'var(--bg4)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'var(--bg3)'; }}>
            Nein, danke
          </button>

          <button
            onClick={handleStartSession}
            disabled={nearbyLeads.length === 0}
            style={{
              flex: 2, height: 40, borderRadius: 10, border: 'none',
              background: nearbyLeads.length > 0 ? 'linear-gradient(135deg, #16a34a, #15803d)' : 'var(--bg4)',
              color: nearbyLeads.length > 0 ? '#fff' : 'var(--text3)',
              fontSize: 13, fontWeight: 600, cursor: nearbyLeads.length > 0 ? 'pointer' : 'default',
              fontFamily: 'inherit',
              boxShadow: nearbyLeads.length > 0 ? '0 2px 10px rgba(22,163,74,0.35)' : 'none',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              transition: 'all .12s',
            }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
            </svg>
            {nearbyLeads.length > 0
              ? `Ja, Call-Liste öffnen (${nearbyLeads.length} Unternehmen)`
              : 'Keine Unternehmen in der Nähe'
            }
          </button>
        </div>
      </div>
    </div>
  );
}
